import { getInforCartToDataLayer } from '@/assist/MiniCart';

export function showAddToCartNotification(title: string = '') {
  const miniCart = document.querySelector('#alt-minicart');
  if (!miniCart) return;

  document.querySelector('.custom_infor_item')?.remove();

  const height = (selector: string) => document.querySelector<HTMLElement>(selector)?.offsetHeight || 0;
  const top = window.scrollY > 0
    ? height('#alt-header-menu-primary') + height('#alt-header-sp')
    : height('.hide-for-countdown') + height('#alt-header-desktop') + height('#alt-header-sp');

  const notification = document.createElement('div');
  notification.className = 'custom_infor_item';
  Object.assign(notification.style, {
    position: 'fixed',
    top: `${top + 10}px`,
    right: '15px',
    padding: '10px',
    border: '1px solid #000',
    background: '#fff',
    display: 'flex',
    gap: '30px',
    zIndex: '98',
    maxWidth: '380px',
  });
  notification.innerHTML = `
    <div class="content_infor">
      <p class="product_name"></p>
      <p>Added to your <a href="#" class="ptOpenMiniCart">Cart</a></p>
    </div>
    <button type="button" class="close_infor" aria-label="Close notification" style="cursor: pointer">X</button>`;

  const productName = notification.querySelector('.product_name');
  if (productName) {
    productName.textContent = title || document.querySelector('.heading_product .entry-title')?.textContent || '';
  }
  notification.querySelector('.ptOpenMiniCart')?.addEventListener('click', (event) => {
    event.preventDefault();
    if (miniCart) {
      miniCart.classList.add('active');
      document.body.classList.add('active_mini_cart');
      getInforCartToDataLayer(true);
    }
  });
  notification.querySelector('.close_infor')?.addEventListener('click', () => notification.remove());
  miniCart.before(notification);
  setTimeout(() => notification.remove(), 4000);
}
